import { render, staticRenderFns } from "./ShopExpiresPopup.vue?vue&type=template&id=f8382ec0&scoped=true"
import script from "./ShopExpiresPopup.vue?vue&type=script&lang=js"
export * from "./ShopExpiresPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8382ec0",
  null
  
)

export default component.exports